// Static option lists for the Payment Processing settings tab's gateway <Select>s (the two
// defaults plus the Card backup). Values are the same composite gateway strings used elsewhere
// in the app (e.g. the DailyProcessing per-row processor dropdown): a bare gateway ('mint',
// 'greenMoney', 'sola', 'lawpay') or a 'mint:<processor>' composite for Mint sub-processors.
// Labels are derived from the shared GATEWAY_LABELS map so they always match the
// labels shown elsewhere (DailyProcessing, ProcessedPayments, ...).
import { formatGatewayValue } from "../../Payments/DailyProcessing/helpers"
import { achGatewayValues, cardGatewayValues } from "../../../constants/gatewayRegistry"

// The Mint sub-processor KEYS a company may save, per rail. Mirrors the backend's
// config.mint.processors DECLARATION order and its deliberate refusal to filter on whether
// MINT_PROCESSOR_*_ID is set: a processor is part of the settable vocabulary once declared, and
// whether it is AVAILABLE for a given payment is answered at charge time by
// /payments/:id/gateway-options.
//
// KNOWN LIMITATION (unchanged by this refactor, do not "fix" it here): a company can therefore
// save cardDefaultGateway='mint:maverick' with no MINT_PROCESSOR_MAVERICK_ID set, and
// gatewayAvailability.getMintProcessorOptions will then never build a matching option, so the
// default silently falls through to the stored rule. Closing that needs a backend warning on
// the settings save, not a frontend list change.
const MINT_COMPOSITE_KEYS = { ACH: ['payliance'], Card: ['maverick', 'humboldt', 'kurv'] }

// ACH default gateway options: the non-Mint ACH gateways plus Mint bare and its
// ACH-capable sub-processor (Payliance). DERIVED from the registry, canonical order.
export const ACH_GATEWAY_VALUES = achGatewayValues(MINT_COMPOSITE_KEYS)

// Card default gateway options: Mint bare plus its card-capable sub-processors, and LawPay.
// DERIVED from the registry, canonical order.
export const CARD_GATEWAY_VALUES = cardGatewayValues(MINT_COMPOSITE_KEYS)

const toOptions = (values) => values.map((value) => ({ value, label: formatGatewayValue(value) }))

export const ACH_GATEWAY_OPTIONS = toOptions(ACH_GATEWAY_VALUES)
export const CARD_GATEWAY_OPTIONS = toOptions(CARD_GATEWAY_VALUES)
// The Card failover destination draws from the same Card vocabulary as the Card default — the
// server validates it against the identical allow-list. The "no backup" choice is not a value
// here: it's an empty <MenuItem> on the control itself, sent as null.
export const CARD_BACKUP_GATEWAY_OPTIONS = toOptions(CARD_GATEWAY_VALUES)
